"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initWordPress;

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _parseQueryString = _interopRequireDefault(require("./parseQueryString"));

var _checkIfWordPress = _interopRequireDefault(require("./checkIfWordPress"));

var _getQueryString = _interopRequireDefault(require("./getQueryString"));

var isWordPress = (0, _checkIfWordPress.default)();

function notifyLocationChange(location) {
  try {
    window.top.postMessage(JSON.stringify({
      leadin_sync_route: location.pathname
    }), '*');
  } catch (e) {//
  }
}

function initWordPress(Raven, history, usageTracker, userInfoPromise) {
  try {
    if (isWordPress) {
      var queryString = (0, _parseQueryString.default)();
      localStorage.setItem('HUB-HTTP_SAFE_MODE', true);
      window.addEventListener('beforeunload', function () {
        localStorage.removeItem('HUB-HTTP_SAFE_MODE');
      });
      var style = document.createElement('style');
      style.type = 'text/css';
      var css = '#hs-nav-v4 { display: none; }';

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      document.getElementsByTagName('head')[0].appendChild(style);

      if (Raven) {
        var php = queryString.php,
            v = queryString.v,
            wp = queryString.wp;
        Raven.setTagsContext({
          leadin: v,
          php: php,
          wordpress: wp
        });
      }

      if (usageTracker) {
        usageTracker.setProperties({
          pluginVersion: queryString.v,
          phpVersion: queryString.php,
          theme: queryString.theme,
          wpVersion: queryString.wp
        });
      }

      if (history) {
        history.listen(notifyLocationChange);
        notifyLocationChange(location);
      }

      if (userInfoPromise) {
        userInfoPromise.catch(function () {
          location.href = "/hubspot-plugin/" + _hubspot.default.getPortalIdFromPath() + "/login?" + (0, _getQueryString.default)();
        });
      }
    }
  } catch (e) {//
  }
}

module.exports = exports.default;